import React, { useEffect, useState } from 'react'
import Layout from '../component/Layout/Layout'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { Form, Modal, Button } from "react-bootstrap";
import { useAuth } from "../context/auth";
import { getPrice,  dateInMDY, OrderStatusFormat } from '../Helper'
import { CreateSupportTicketAPI } from '../component/APIS';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSupportTicketAPI } from '../hooks/useAllCategoryData';
import { messageClass } from '../Helper';
export default function SupportTicket() {
    const queryClient = useQueryClient();
    const [validated, setValidated] = useState(false);
    const [supportData, setSupportData] = useState({});
    const [auth] = useAuth();
    const [userId, setUserId] = useState(auth?.user?.id);

    const [show, setShow] = useState(false);
    const [updateMsg, setUpdateMsg] = useState('');
    const [currentAdd, setCurrentAdd] = useState({
        customer_id:userId,
        subject:'',
        type:'',
        priority:'',
        description:''
    });

    const getSupportTicket = async () => {
        try {
            const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/customer/support-ticket/get?customer_id=${userId}`);
            setSupportData(data);
            //console.log(data)
        } catch (error) {
            //console.log(error)
        }
    } 

   //const { error, data:supportData1 } = useSupportTicketAPI(userId);
   //if (error) return <div>{error.message}</div>;
   //if (error) return <div>{error.message}</div>;


    
    const changeHandle = async(event)=>{
        const form = event.currentTarget;
        let value = event.target.value;
          let name = event.target.name;
          setCurrentAdd({
            ...currentAdd,
              [name]:value
          })
          //console.log(name,value)
    }

    const handleClose = () => setShow(false);

    const handleAdd = () => {
        setShow(true)
    }
    const addMutation = useMutation({
        mutationFn:CreateSupportTicketAPI,
        onSuccess:()=>{
         // queryClient.invalidateQueries({queryKey:['ticket']});
          setUpdateMsg('Ticket created Successfully!');
          setCurrentAdd({
            subject:'',
            type:'',
            priority:'',
            description:''
        })
        setValidated(false);
        setTimeout(() => {
            handleClose();
        }, 1000);
        getSupportTicket();
        }
    }); 

    const handleCreateTicket = async(e)=>{
        const form = e.currentTarget;
        e.preventDefault();
        setValidated(true);
        if(form.checkValidity()===true) {
            //setUpdateMsg('Updateing...');
            //console.log('object',currentAdd)
            addMutation.mutate(currentAdd);
        }
    } 

   

   useEffect(() => {
        getSupportTicket();
    }, []);

    return (
        <Layout title="Support Ticket | Chaashni Couture">
            <div className="site-content-wrap my-account">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h1 className="sustom-heading-h1 sustom-heading-flex d-flex justify-content-between align-items-center flex-md-nowrap"><div style={{width:"130px"}}></div> <div>Support <span> Ticket</span></div> <div><Link onClick={() => { handleAdd() }} className="btn btn-primary p-2">+ Add New Ticket</Link></div></h1>
                            
                            <div className="content-box">
                                <div className="wishlist-table table-responsive">

                                    <table className="shop_table cart wishlist_table custom-table">
                                        <thead>
                                            <tr>
                                                <th className="order-th">Topic</th>
                                                <th className="data-th">Date</th>
                                                <th className="status-th">Type</th>
                                                <th className="status-th">Priority</th>
                                                <th className="total-th">Status</th>
                                                <th className="action-th">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {supportData.length > 0 && supportData?.map((item, index) => (
                                                <tr key={index}>
                                                    <td className="order-th">{item.subject}</td>
                                                    <td className="data-th">{dateInMDY(item.created_at)}</td>
                                                    <td className="status-th">{item.type} </td>
                                                    <td className="total-th">{item.priority} </td>
                                                    <td className="total-th">
                                                    
                                                     <span className={messageClass(item.status)}>{item.status}</span>     
                                                    </td>
                                                    <td className="action-th"><Link title="View Details" to={`/support-ticket/${item.id}`}><i className="fa fa-eye"></i></Link></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                </div>

                                <Modal show={show} onHide={handleClose}>
                                    <Form noValidate validated={validated} onSubmit={handleCreateTicket} className="edit-address-form">
                                        <Modal.Header closeButton>
                                            <Modal.Title>Create Ticket</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            {updateMsg !== '' ? (
                                                <p className="text-success text-center">{updateMsg}</p>
                                            ) : ''}
                                            <Form.Group className="mb-3" controlId="exampleForm.ContactPersonName">
                                                <Form.Control
                                                    type="text"
                                                    name="subject"
                                                    placeholder="Subject"
                                                    value={currentAdd?.subject}
                                                    onChange={changeHandle}
                                                    autoFocus
                                                    required
                                                />
                                            </Form.Group>
                                            
                                            <Form.Group className="mb-3" controlId="exampleForm.messagetype">
                                                <Form.Select aria-label="select Message type" name="type" value={currentAdd?.type} defaultValue={currentAdd?.type} onChange={changeHandle} required>
                                                    <option value="">-Support Type-</option>
                                                    <option value="Info inquiry">Info inquiry</option>
                                                    <option value="Problem">Problem</option>
                                                    <option value="Complaint">Complaint</option>
                                                    <option value="Request">Request</option>
                                                </Form.Select>
                                            </Form.Group>

                                             <Form.Group className="mb-3" controlId="exampleForm.Addresstype">
                                                <Form.Select aria-label="select Message priority" name="priority" value={currentAdd?.priority} defaultValue={currentAdd?.priority} onChange={changeHandle} required>
                                                    <option value="">-Priority-</option>
                                                    <option value="Urgent">Urgent</option>
                                                    <option value="High">High</option>
                                                    <option value="Medium">Medium</option>
                                                    <option value="Low">Low</option>
                                                </Form.Select>
                                            </Form.Group>    

                                            <Form.Group className="mb-3" controlId="exampleForm.description">
                                                <Form.Label>Description</Form.Label>
                                                <Form.Control as="textarea" required name="description" rows={3} value={currentAdd?.description} onChange={changeHandle} />
                                            </Form.Group>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="primary" type="submit">Create Ticket</Button>
                                        </Modal.Footer>
                                    </Form>

                                </Modal>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}